import { ITransshipment, TTransshipmentStepId } from '../../types';

const step = {
  path: 'avalista/estado-civil',
  next: (trans: ITransshipment): TTransshipmentStepId => {
    if (
      trans.type === 'representative' &&
      trans.data.marital_status === 'married' &&
      ['community-of-property', 'partial-community-of-property'].includes(
        trans.data.marriage_regime
      )
    )
      return 'spouse-register-page';

    return 'identity-document-type-page';
  },
};

export default step;
